import { Input, Directive } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { Filter } from "src/components/shared-components/class/general-classes/filter";
import { EventService } from "src/service/event.service";

/**
 * Base class for filter: used to handle translations and input; the output is handled in the master component
 */
@Directive()
export class FilterBaseComponent {
  @Input('Filter') Filter: Filter = null;

  public title: string = "";

  private _translateSubscription: Subscription;

  constructor(protected _eventService: EventService, protected _translateService: TranslateService) {
  }

  protected baseOnDestroy() {
    this._translateSubscription.unsubscribe();
  }

  /**
   * Load translation (for title of filter)
   */
  protected baseLoadTranslation() {
    this._translateService
      .get([
        this.Filter.Title
      ])
      .subscribe((translation) => {
        this.title = translation[this.Filter.Title];
      });
  }

  /**
   * Subscribe on language changed
   */
  protected baseSubscribeTranslationEvent() {
    this._translateSubscription = this._translateService.onLangChange.subscribe(() => {
      this.baseLoadTranslation();
    });
  }
}
